import { Modal, Button, Result } from 'antd';
import { QuestionCircleFilled } from '@ant-design/icons';

const SavePublishedAsDraftModal = ({ 
    isVisible, 
    onCancel, 
    onConfirm, 
    statusTokens 
}) => {
    return (
        <Modal
            open={isVisible}
            onCancel={onCancel}
            centered={true}
            footer={null}
        >
            <Result
                icon={<QuestionCircleFilled style={{ color: statusTokens?.warning || '#faad14', fontSize: '72px' }} />}
                title="Save as Draft"
                subTitle="Do you want to save the changes as a draft?"
                extra={[
                    <Button key="save" type="primary" onClick={onConfirm}>
                        Save as Draft
                    </Button>,
                    <Button key="cancel" onClick={onCancel}>
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default SavePublishedAsDraftModal;
